import axios from "../utils/axios";
import { environment } from "environments/environment";

const baseURL = environment.apiUrl;

export const login = async (model) => {
  const response = await axios.post(`${baseURL}/auth/login`, model);
  return response;
};

export const register = async (model) => {
  const response = await axios.post(`${baseURL}/auth/register`, model);
  return response;
};

export const logout = async () => {
  const response = await axios.post(`${baseURL}/auth/logout`);
  return response;
};

export const forgotPassword = async (model) => {
  const response = await axios.post(`${baseURL}/auth/forgot-password`, model);
  return response;
};

export const saveBudgetType = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-budget-type`, model);
  return response;
};

export const updateBudgetType = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-budget-type`, model);
  return response;
};

export const getBudgetTypeList = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-budget-type-list`);
  return response;
};

export const getBudgetType = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-budget-type`, model);
  return response;
};

export const saveCompany = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-company`, model);
  return response;
};

export const updateCompany = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-company`, model);
  return response;
};

export const getCompanyList = async () => {
  const response = await axios.get(`${baseURL}/field/get-company-list`);
  return response;
};

export const getCompany = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-company`, model);
  return response;
};

export const saveCompanyLocation = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-companyLocation`, model);
  return response;
};

export const getCompanyLocationList = async () => {
  const response = await axios.get(`${baseURL}/field/get-companyLocation-list`);
  return response;
};

export const getCompanyLocation = async (model) => {
  const response = await axios.post(`${baseURL}/field/get-companyLocation`, model);
  return response;
};

export const saveEducationStatus = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-education-status`, model);
  return response;
};

export const updateEducationStatus = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-education-status`, model);
  return response;
};

export const getEducationStatusList = async () => {
  const response = await axios.get(`${baseURL}/field/get-education-status-list`);
  return response;
};

export const getEducationStatus = async (model) => {
  const response = await axios.post(`${baseURL}/field/get-education-status`, model);
  return response;
};

export const saveContractTypes = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-contract-types`, model);
  return response;
};

export const updateContractTypes = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-contract-types`, model);
  return response;
};

export const getContractTypesList = async () => {
  const response = await axios.get(`${baseURL}/field/get-contract-types-list`);
  return response;
};

export const getContractTypes = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-contract-types`, model);
  return response;
};

export const saveFoodTypes = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-food-types`, model);
  return response;
};

export const updateFoodTypes = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-food-types`, model);
  return response;
};

export const getFoodTypes = async (model) => {
  const response = await axios.post(`${baseURL}/field/get-food-types`, model);
  return response;
};

export const getFoodTypesList = async () => {
  const response = await axios.post(`${baseURL}/field/get-food-types-list`);
  return response;
};

export const saveDeparmant = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-departmant`, model);
  return response;
};

export const updateDeparmant = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-departmant`, model);
  return response;
};

export const updateDeparmantList = async () => {
  const response = await axios.post(`${baseURL}/field/update-departmant-list`);
  return response;
};

export const getDeparmant = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-departmant`, model);
  return response;
};

export const getDeparmantList = async () => {
  const response = await axios.get(`${baseURL}/field/get-departmant-list`);
  return response;
};

export const saveFormType = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-form-type`, model);
  return response;
};

export const updateFormType = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-form-type`, model);
  return response;
};

export const getFormType = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-form-type`, model);
  return response;
};

export const getFormTypeList = async () => {
  const response = await axios.get(`${baseURL}/field/get-form-type-list`);
  return response;
};

export const saveFormStatus = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-form-status`, model);
  return response;
};

export const updateFormStatus = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-form-status`, model);
  return response;
};

export const getFormStatus = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-form-status`, model);
  return response;
};

export const getFormStatusList = async () => {
  const response = await axios.get(`${baseURL}/field/get-form-status-list`);
  return response;
};

export const saveExperience = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-experience`, model);
  return response;
};

export const updateExperience = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-experience`, model);
  return response;
};

export const getExperienceList = async () => {
  const response = await axios.get(`${baseURL}/field/get-experience-list`);
  return response;
};

export const getExperience = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-experience-list`, model);
  return response;
};

export const saveLocation = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-location`, model);
  return response;
};

export const updateLocation = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-location`, model);
  return response;
};

export const getLocationList = async () => {
  const response = await axios.get(`${baseURL}/field/get-location-list`);
  return response;
};

export const getLocation = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-location`, model);
  return response;
};

export const saveSubLocation = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-sub-location`, model);
  return response;
};

export const updateSubLocation = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-sub-location`, model);
  return response;
};

export const getSubLocation = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-sub-location`, model);
  return response;
};

export const getSubLocationList = async () => {
  const response = await axios.get(`${baseURL}/field/get-sub-location-list`);
  return response;
};

export const saveForeignLanguage = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-foreign-language`, model);
  return response;
};

export const updateForeignLanguage = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-foreign-language`, model);
  return response;
};

export const getForeignLanguage = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-foreign-language`, model);
  return response;
};

export const getForeignLanguageList = async () => {
  const response = await axios.get(`${baseURL}/field/get-foreign-language-list`);
  return response;
};

export const saveSalaryType = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-salary-type`, model);
  return response;
};

export const updateSalaryType = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-salary-type`, model);
  return response;
};

export const getSalaryType = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-salary-type`, model);
  return response;
};

export const getSalaryTypeList = async () => {
  const response = await axios.post(`${baseURL}/field/save-salary-type-list`);
  return response;
};

export const saveWorkerType = async () => {
  const response = await axios.post(`${baseURL}/field/save-worker-type`);
  return response;
};

export const updateWorkerType = async () => {
  const response = await axios.post(`${baseURL}/field/update-worker-type`);
  return response;
};

export const getWorkerType = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-worker-type`, model);
  return response;
};

export const getWorkerTypeList = async () => {
  const response = await axios.get(`${baseURL}/field/get-worker-type-list`);
  return response;
};

export const saveVehicleType = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-vehicle-type`, model);
  return response;
};

export const updateVehicleType = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-vehicle-type`, model);
  return response;
};

export const getVehicleType = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-vehicle-type`, model);
  return response;
};

export const getVehicleTypeList = async () => {
  const response = await axios.get(`${baseURL}/field/get-vehicle-type`);
  return response;
};

export const saveTitle = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-title`, model);
  return response;
};

export const updateTitle = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-title`, model);
  return response;
};

export const getTitle = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-title`, model);
  return response;
};

export const getTitleList = async () => {
  const response = await axios.get(`${baseURL}/field/get-title-list`);
  return response;
};

export const savePositionType = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-position-type`, model);
  return response;
};

export const updatePositionType = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-position-type`, model);
  return response;
};

export const getPositionType = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-position-type`, model);
  return response;
};

export const getPositionTypeList = async () => {
  const response = await axios.get(`${baseURL}/field/get-position-type-list`);
  return response;
};

export const saveGender = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-gender`, model);
  return response;
};

export const updateGender = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-gender`, model);
  return response;
};

export const getGenderList = async () => {
  const response = await axios.get(`${baseURL}/field/get-gender-list`);
  return response;
};

export const getGender = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-gender`, model);
  return response;
};

export const saveCompletionType = async (model) => {
  const response = await axios.post(`${baseURL}/field/save-completion-type`, model);
  return response;
};

export const updateCompletionType = async (model) => {
  const response = await axios.post(`${baseURL}/field/update-completion-type`, model);
  return response;
};

export const getCompletionTypeList = async () => {
  const response = await axios.get(`${baseURL}/field/get-completion-type-list`);
  return response;
};

export const getCompletionType = async (model) => {
  const response = await axios.get(`${baseURL}/field/get-completion-type`, model);
  return response;
};
